import React, { useRef, useState } from "react";
import { RotateCcw, RotateCw } from "lucide-react";
import "./cropCanvas.css";

const CropCanvas = ({
  imageSrc,
  zoom = 1,
  rotation = 0,
  position = { x: 0, y: 0 },
  onZoomChange = () => {},
  onRotationChange = () => {},
  onPositionChange = () => {},
}) => {
  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      const newPosition = {
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y,
      };
      onPositionChange(newPosition);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const onZoomInputChange = (e) => {
    onZoomChange(parseFloat(e.target.value));
  };

  return (
    <div className="crop-container">
      <div
        ref={containerRef}
        className="crop-area"
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
      >
        <div
          className="image-wrapper"
          style={{
            transform: `translate(-50%, -50%) translate(${position.x}px, ${position.y}px) rotate(${rotation}deg) scale(${zoom})`,

            cursor: isDragging ? "grabbing" : "grab",
          }}
        >
          <img
            src={imageSrc}
            alt="Crop"
            className="max-w-none"
            draggable={false}
          />
        </div>

        <div className="crop-overlay">
          <div className="crop-box">
            <div className="corner tl" />
            <div className="corner tr" />
            <div className="corner bl" />
            <div className="corner br" />
          </div>
        </div>
      </div>

      <div className="controls">
        <div className="control-group">
          <div className="control-labels">
            <span>Zoom</span>
            <span className="control-value">{zoom.toFixed(1)}x</span>
          </div>
          <input
            type="range"
            min="1"
            max="3"
            step="0.1"
            value={zoom}
            onChange={onZoomInputChange}
            className="slider"
          />
        </div>
      </div>
    </div>
  );
};

export default CropCanvas;
